import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function WizConnectForm({ onSubmit, guideMode }) {
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);
  const formInitialValues = {
    client_id: "",
    client_secret: "",
    api_endpoint_url: "",
  };
  const formCheckoutSchema = yup.object().shape({
    client_id: yup.string().required("required"),
    client_secret: yup.string().required("required"),
    api_endpoint_url: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="client_id"
                label="Client ID"
                value={values.client_id}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.client_id && !!errors.client_id}
                helperText={touched.client_id && errors.client_id}
                autoComplete="off"
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="client_secret"
                label="Client Secret"
                type={showSecret ? "text" : "password"}
                value={values.client_secret}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.client_secret && !!errors.client_secret}
                helperText={touched.client_secret && errors.client_secret}
                autoComplete="off"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="api_endpoint_url"
                label="API endpoint URL"
                value={values.api_endpoint_url}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.api_endpoint_url && !!errors.api_endpoint_url}
                helperText={touched.api_endpoint_url && errors.api_endpoint_url}
                autoComplete="off"
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
